export default {
  "footer_title_related-sites": "Related Sites",
  "___footer_title_resources": "",
  "footer_title_need-help": "Need Help?",
  "___footer_link_non-discrimination": "",
  "___footer_link_legal-terms-of-use": "",
  "___footer_link_privacy-policy": "",
  "___footer_link_security-policy": "",
  "___footer_link_contact-us": "",
  "footer_text_copyright": "Copyright %company% %currentYear% All Rights Reserved",
  "footer_text_logo-alt": "SelectAccount",
  "footer-vermont-translate-english": "For free language-assistance services, call (800) 247-2583.",
  "footer-vermont-translate-spanish": "Para servicios gratuitos de asistencia con el idioma, llame al (800) 247-2583.",
  "footer-vermont-translate-french": "Por obtenir des services d\'assistance linguistique gratuits, appelez le (800) 247-2583.",
  "footer-vermont-licensee": "Blue Cross and Blue Shield of Vermont is an Independent Licensee of the Blue Cross and Blue Shield Association.",
};